import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { fetchCapabilities } from '@/hooks/use-capabilities'
import { supabase } from '@/lib/supabase'

export const Route = createFileRoute('/_authed/admin')({
  beforeLoad: async () => {
    const {
      data: { user },
    } = await supabase.auth.getUser()
    if (!user) throw redirect({ to: '/login' })

    const capabilities = await fetchCapabilities(user.id)
    // canAccessAdmin admits only capabilities with an admin PAGE behind them
    // (users.manage, settings.manage) — per-page guards live on the children.
    // Denied users go to a real surface, not the /dashboard placeholder (F3).
    if (!capabilities.canAccessAdmin) throw redirect({ to: '/accounts' })
  },
  component: () => <Outlet />,
})
